var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCaret = function SvgCaret(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.135 3.37a.631.631 0 0 0-.01.907L5.468 8.62a.664.664 0 0 0 .94 0l4.343-4.342a.631.631 0 0 0-.011-.907.668.668 0 0 0-.929.01L5.937 7.254 2.064 3.381a.668.668 0 0 0-.929-.01Z",
    fill: "currentColor"
  })));
};
export default SvgCaret;